import { useEffect, useState } from 'react'
import { ImageWithArtDirection } from 'src/components/ui/Image'
import Link from 'src/components/ui/Link'
import imagesConf from 'src/images/config'
import { mark } from 'src/sdk/tests/mark'

import Section from '../Section'
import './bannercategory.scss'

export interface BannerCategoryProps {
  banners: [
    {
      src: string
      label: string
      alt: string
      href: string
    }
  ]
  marginTop?: string
  marginBottom?: string
}
function BannerCategory({
  banners,
  marginBottom,
  marginTop,
}: BannerCategoryProps) {
  const [isPLP, setisPLP] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setisPLP(document.getElementsByClassName('product-listing').length > 0)
    }
  }, [])

  return (
    <Section
      style={{
        marginTop: `${marginTop ?? ' '}`,
        marginBottom: `${marginBottom ?? ' '}`,
      }}
    >
      <div
        className={`category__banner-section ${
          isPLP ? 'category__banner-product-list' : ''
        }`}
      >
        {banners.map((banner, index) => (
          <Link
            aria-label={banner.label ? `${banner.label}` : 'Link categoria'}
            as="a"
            href={banner.href}
            key={index}
          >
            <button
              aria-label={banner.label ? `${banner.label}` : 'Icona categoria'}
              className="category__banner-button"
            >
              <ImageWithArtDirection
                desktop={{
                  baseUrl: `${banner.src}`,
                  ...imagesConf['catimages.desktop'],
                }}
                mobile={{
                  baseUrl: `${banner.src}`,
                  ...imagesConf['catimages.mobile'],
                }}
                alt={banner.alt}
                objectFit="cover"
                loading="eager"
                className="category__banner-img"
              />
              <p className="category__banner-title">{banner.label}</p>
            </button>
          </Link>
        ))}
      </div>
    </Section>
  )
}

export default mark(BannerCategory)
